import { render, staticRenderFns } from "./hotspot.vue?vue&type=template&id=f7fe5476&scoped=true&lang=pug"
import script from "./hotspot.vue?vue&type=script&lang=js"
export * from "./hotspot.vue?vue&type=script&lang=js"
import style0 from "./hotspot.vue?vue&type=style&index=0&id=f7fe5476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fe5476",
  null
  
)

export default component.exports